const COLORS = { facebook: "#1877F2", instagram: "#C13584", linkedin: "#0A66C2", x: "#0F172A", youtube: "#DC2626", tiktok: "#111827", whatsapp: "#16A34A", website: "#0B2A7A", other: "#C9962E" };
const EN = { website: "Website", other: "Link" };

export const XaltixSignaturePreview = ({ text, links, networks, lang }) => {
  const shown = (links || []).filter((l) => (l.url || "").trim());
  return (
    <div className="rounded-md border border-slate-200 bg-[#eef1f8] p-4" data-testid="xaltix-signature-preview">
      <div className="text-[11px] font-bold uppercase tracking-wider text-slate-500 mb-2">Aperçu en direct — bas des e-mails ({lang.toUpperCase()})</div>
      <div className="bg-white rounded-md border border-slate-200 px-5 pb-4 pt-3" style={{ fontFamily: "Arial, Helvetica, sans-serif" }}>
        <p className="text-sm text-slate-400 italic">… contenu de l'e-mail …</p>
        <div className="mt-4 pt-4 border-t border-slate-200">
          <img src="/xaltix-emblem.png" alt="XALTIX" className="w-11 h-auto mb-2" />
          <div className="text-[13px] leading-relaxed text-slate-700 whitespace-pre-line" data-testid="xaltix-signature-preview-text">{text || <span className="text-slate-400">Signature vide</span>}</div>
          {shown.length > 0 && (
            <div className="flex flex-wrap gap-1.5 mt-1.5">
              {shown.map((l, i) => (
                <span key={i} className="inline-block px-3.5 py-1.5 rounded-full text-white text-xs font-bold" style={{ background: COLORS[l.network] || COLORS.other }} data-testid={`xaltix-signature-preview-btn-${i}`}>
                  {l.label?.trim() || (lang === "en" && EN[l.network]) || networks?.[l.network] || "Lien"}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
